import { Component, Inject, Prop, Vue } from 'vue-property-decorator';
import { Store } from '@/primary/store/Store';
import { ProjectListVue } from '@/primary/template-right-bar/country-sidebar/project-list';
import { Project } from '@/domain/project/Project';

@Component({ components: { ProjectListVue } })
export default class CountrySidebarComponent extends Vue {
  @Prop({ type: String, required: true })
  readonly countryId!: string;

  @Inject()
  private store!: () => Store;

  get country() {
    const found = this.store()
      .getCountries()
      .find(country => country.id === this.countryId);
    return found || null;
  }

  get projects(): Project[] {
    return this.store()
      .getFilteredProjects()
      .filter(project => project.countries.indexOf(this.countryId) > -1);
  }
}
